import React, { useCallback, useRef, useState } from "react";
import {
  PhoneOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import { HiOutlineQueueList } from "react-icons/hi2";
import type { MenuProps, TourProps } from "antd";
import {  Drawer, Layout, Menu, Tour } from "antd";
import { useThemes, i18n, useLanguage, routesName } from "core/src";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoMdClose } from "react-icons/io";

import { MyHeader, PasswordChange, Profile } from "components/src";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Main } from "./main";
import { createUseStyles } from "react-jss";
import { BiServer } from "react-icons/bi";
import { Roles } from "../roles";
import { Users } from "../users";
import { Channels } from "../channels";
import { Groups } from "../groups";
import { Reports } from "../reports";
import { Access } from "../access/access";
import { Categories } from "../categories";

const { Content, Footer, Sider } = Layout;

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const useStyle = createUseStyles({
  menu: {
    "@media (max-width: 658px)": {
      display: "none",
      zIndex: 999,
    },
  },
  content: {
    padding: 40,
    "@media(max-width:658px)": {
      padding: 10,
    },
  },
  slider: {
    "@media(max-width:658px)": {
      display: "none",
    },
  },
  burger: {
    "@media(min-width:658px)": {
      display: "none",
    },
  },
});

const Dashboard: React.FC = () => {
  const MAX_WIDTH = 458;
  const isMaxWidth458OrLess = window.innerWidth <= MAX_WIDTH;
  const [collapsed, setCollapsed] = useState(isMaxWidth458OrLess);
  const { colors: theme, name } = useThemes();
  const classes = useStyle();
  const { language } = useLanguage();
  const [openDrawerPro, setOpenDrawerPro] = useState(false);
  const [openDrawerPass, setOpenDrawerPass] = useState(false);
  const [open, setOpen] = useState(false);
  
  const navigate = useNavigate();
  const handleTour = useCallback(() => {
    setOpen(true);
  }, []);
  const handleprofile = useCallback(() => {
    setOpenDrawerPro(true);
  }, []);
  const onClose = () => {
    setOpenDrawerPro(false);
  };

  const handlepasswordChange = useCallback(() => {
    setOpenDrawerPass(true);
  }, []);
  const onClosePass = () => {
    setOpenDrawerPass(false);
  };

  const handleBurger = () => {
    setCollapsed(!collapsed);
  };
  

  const ref1 = useRef<HTMLButtonElement>(null);
  const ref2 = useRef<HTMLButtonElement>(null);
  const steps: TourProps["steps"] = [
    {
      title: i18n.t("ChangeTheme"),
      description: i18n.t("ChangeTheme"),
      target: () => ref1.current!,
    },
    {
      title: i18n.t("ChangeTheme"),
      description: i18n.t("ChangeTheme"),
      target: () => ref2.current!,
    },
  ];
  const items: MenuItem[] = [
    getItem(
      i18n.t("dashboard"),
      routesName.DASHBOARD,
      <PieChartOutlined ref={ref1} />
    ),
    getItem(i18n.t("basicInformation"), routesName.DASHBOARD, <BiServer />, [
      getItem(i18n.t("users"), routesName.USERS,<BiServer />,[
        getItem(i18n.t("usersList"), routesName.USERSLIST),
        getItem(i18n.t("addUser"), routesName.ADDUSER),
      ]),
      getItem(i18n.t("roles"), routesName.ROLES,<BiServer />,[
        getItem(i18n.t("rolesList"), routesName.ROLESLIST),
        getItem(i18n.t("addRole"), routesName.ADDROLE),
      ]),
      getItem(i18n.t("channels"), routesName.CHANNELS,<BiServer />,[
        getItem(i18n.t("channelsList"), routesName.CHANNELSLIST),
        getItem(i18n.t("addChannel"), routesName.ADDCHANNEL),
      ]),
      getItem(i18n.t("chatGroups"), routesName.GROUPS,<BiServer />,[
        getItem(i18n.t("groupsList"), routesName.GROUPSLIST),
        // getItem(i18n.t("addGroup"), routesName.ADDGROUP)
      ]),
      getItem(i18n.t("categories"), routesName.CATEGORIES,<BiServer />,[
        getItem(i18n.t("categoriesList"), routesName.CATEGORIESLIST),
        getItem(i18n.t("addCategory"), routesName.ADDCATEGORY),
      ]),
    ]),
    getItem(
      i18n.t("access"),
      routesName.ACCESS,
      <PhoneOutlined ref={ref2} />,
      [
        getItem(i18n.t("operationalAccess"), routesName.OPRATIONALACCESSLIST),
        // getItem(i18n.t("MandatoryMembership"), routesName.MANDATORYMEMBERSHIPLIST),
      ]
    ),
    getItem(i18n.t("reports"), routesName.REPORTS, <HiOutlineQueueList />, [
      getItem(i18n.t("messages"), routesName.MESSAGESREPORT),
    ]),
      // getItem(i18n.t("domains"), routesName.DASHBOARD),
    // ]
    // ),
  ]; //slider items

  const handleItemClick = useCallback(
    (e: any) => {
      let path = "";
      e.keyPath.reverse().map((item: any) => (path += item + "/"));
      navigate(path);
      if (isMaxWidth458OrLess) {
        handleBurger();
      }
    },
    [handleBurger]
  );
  return (
    <>
      <MyHeader
        hamburgerMenu={
          <div className={classes.burger}>
            {collapsed ? (
              <RxHamburgerMenu
              onClick={handleBurger}
              style={{ marginTop: 25, marginRight: 20 }}
              size={30}
              />
              ) : (
                <IoMdClose
                onClick={handleBurger}
                style={{ marginTop: 25, marginRight: 20 }}
                size={30}
                />
                )}
          </div>
        }
        tourBtn={false}
        themeSwitch={true}
        languageSwitch={true}
        profileBtn={true}
        tourHandler={handleTour}
        profileHandler={handleprofile}
        changePasswordHandler={handlepasswordChange}
      />
      <Layout style={{ minHeight: "100vh" }}>
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          style={{ backgroundColor: theme.black }}
          className={collapsed ? classes.slider : ""}
          width={isMaxWidth458OrLess ? window.innerWidth : 250}
          collapsedWidth={isMaxWidth458OrLess ? 50 : 100}
        >
          <div className="demo-logo-vertical" />

          <Menu
            style={{ height: "100%" }}
            mode="inline"
            theme={name}
            defaultSelectedKeys={["1"]}
            items={items}
            onClick={handleItemClick}
            className={collapsed ? classes.menu : ""}
          />
        </Sider>
        <Layout>
          <Content className={classes.content}>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path={`${routesName.USERS}/*`} element={<Users/>}/>
              <Route path={`${routesName.ROLES}/*`} element={<Roles/>}/>
              <Route path={`${routesName.CHANNELS}/*`} element={<Channels/>}/>     
              <Route path={`${routesName.GROUPS}/*`} element={<Groups/>} />
              <Route path={`${routesName.ACCESS}/*`} element={<Access/>} /> 
              <Route path={`${routesName.REPORTS}/*`} element={<Reports/>} /> 
              <Route path={`${routesName.CATEGORIES}/*`} element={<Categories/>} /> 
            </Routes>
          </Content>
          {/* <Footer
            style={{
              textAlign: 'center',
              position:'sticky',
              bottom:0,
            }}
          >
            {i18n.t('autoDialar')}
          </Footer> */}
        </Layout>
      </Layout>
      <Tour
        open={open}
        onClose={() => setOpen(false)}
        steps={steps}
        indicatorsRender={(current, total) => (
          <span>
            {current + 1} / {total}
          </span>
        )}
      />
      <Drawer
        width={"80%"}
        title={i18n.t("profile")}
        placement={language === "fa" ? "left" : "right"}
        closable={false}
        onClose={onClose}
        open={openDrawerPro}
        // key={"left"}
      >
        <Profile />
      </Drawer>
      <Drawer
        width={"80%"}
        title={i18n.t("changePassword")}
        placement={language === "fa" ? "left" : "right"}
        closable={false}
        onClose={onClosePass}
        open={openDrawerPass}
        // key={"left"}
      >
        <PasswordChange />
      </Drawer>
    </>
  );
};

export { Dashboard };
